import { arrayToBase64, crc16 } from '@lucidlink/ts-crypto/crypto';
export const generateGuestLink = (baseUrl, linkId, linkSecret) => {
    const url = new URL(`/guest/${linkId}`, baseUrl);
    url.hash = `${linkSecret}.${integrityCheck(linkId, linkSecret)}`;
    return url;
};
export const parseGuestLinkFragment = (linkId, fragment) => {
    if (!isValidGuestLinkId(linkId)) {
        return null;
    }
    const hash = fragment.startsWith('#') ? fragment.slice(1) : fragment;
    const segments = hash.split('.');
    if (segments.length !== 2) {
        return null;
    }
    const [linkSecret, check] = segments;
    if (!isBase64Url(linkSecret, LINK_SECRET_LENGTH) ||
        !isBase64Url(check, CHECK_LENGTH)) {
        return null;
    }
    if (check !== integrityCheck(linkId, linkSecret)) {
        return null;
    }
    return linkSecret;
};
export const isValidGuestLinkId = (linkId) => isBase64Url(linkId, GUEST_LINK_ID_LENGTH);
const GUEST_LINK_ID_LENGTH = 20;
// The 32-byte link secret in unpadded base64url form.
const LINK_SECRET_LENGTH = 43;
const CHECK_LENGTH = 3;
const BASE64_URL_ALPHABET = new Set('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_');
const isBase64Url = (value, length) => value.length === length &&
    [...value].every((char) => BASE64_URL_ALPHABET.has(char));
/**
 * CRC-16 check over the link id and the link secret, encoded as 3 base64url
 * characters. Detects accidental link corruption (truncation, mangled
 * characters, id/secret mix-ups) without a server round trip; it is an
 * integrity check, not a security control.
 */
const integrityCheck = (linkId, linkSecret) => {
    const crc = crc16(`${linkId}.${linkSecret}`);
    const bytes = new Uint8Array([(crc >>> 8) & 0xff, crc & 0xff]);
    return arrayToBase64(bytes.buffer, { urlSafe: true });
};
